import { AppLayout } from "@core/components/layout/AppLayout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/_headed")({
  component: AppLayout,
});
